import React, { useState, useEffect } from "react";
import { TextField, Button, Typography, Box } from "@mui/material";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";

const StepPhoneRegister = ({
  userName,
  emailId,
  loading,
  setUserName,
  setEmailId,
  handleSendOtp,
  setShowLogin,
}) => {
  const [errors, setErrors] = useState({ userName: "", emailId: "" });

  const validateFields = () => {
    const newErrors = { userName: "", emailId: "" };

    if (!userName.trim()) {
      newErrors.userName = "User Name is required";
    }

    if (!emailId.trim()) {
      newErrors.emailId = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailId)) {
      newErrors.emailId = "Invalid email format";
    }

    setErrors(newErrors);

    return !newErrors.userName && !newErrors.emailId;
  };

  const handleSubmit = () => {
    if (validateFields()) {
      handleSendOtp();
    }
  };

  useEffect(() => {
    // Clear errors while typing
    if (userName || emailId) {
      setErrors({ userName: "", emailId: "" });
    }
  }, [userName, emailId]);

  return (
    <div style={{ display: "flex", gap: "10px", flexDirection: "column" }}>
      <Box textAlign="center" mb={1}>
        <PhoneAndroidIcon fontSize="large" color="primary" />
      </Box>
      <h2>For the Doctors Appointment</h2>
      <p>Please register your Email</p>
      <small style={{ color: "GrayText" }}>
        OTP will be sent to this Email Id
      </small>

      <TextField
        size="small"
        fullWidth
        label="User Name"
        placeholder="Enter User Name"
        value={userName}
        onChange={(e) => setUserName(e.target.value)}
        error={!!errors.userName}
        helperText={errors.userName}
        margin="normal"
      />

      <TextField
        size="small"
        fullWidth
        label="Email"
        placeholder="Enter email"
        value={emailId}
        onChange={(e) => setEmailId(e.target.value)}
        error={!!errors.emailId}
        helperText={errors.emailId}
        margin="normal"
      />

      <small style={{ color: "GrayText" }}>
        By continuing, you agree to the terms and privacy policy of TrustDoc.
      </small>

      <Button
        variant="contained"
        fullWidth
        onClick={handleSubmit}
        disabled={loading}
        sx={{ mt: 2 }}
      >
        {loading ? "Sending..." : "Send OTP"}
      </Button>

      <Typography variant="body2" textAlign="center" sx={{ mt: 1 }}>
        Already have an account?{" "}
        <span
          style={{
            color: "#1976d2",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={() => setShowLogin(true)}
        >
          Login here
        </span>
      </Typography>
    </div>
  );
};

export default StepPhoneRegister;
